export class InvalidAuthStateError extends Error {}
